<template>
  <div id="resellers">  
    <!-- <div class="recorrido">
      <div class="step">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="90" height="90"><path fill="none" d="M0 0h24v24H0z"/><path d="M2 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 1 0 0 5V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 1 0 0-5zM14 5H4v2.968a4.5 4.5 0 0 1 0 8.064V19h10V5zm2 0v14h4v-2.968a4.5 4.5 0 0 1 0-8.064V5h-4z" fill="rgba(0,64,255,1)"/></svg>
        <div class="texto">
          <h3>{{ $t('dealers.createCoupon') }}</h3>
          <p>{{ $t('dealers.genericCoupons') }}</p>
        </div>
      </div>
      <div class="step">
        <send-icon size="1.5x" class="custom-class"></send-icon>
        <div class="texto">
          <h3>{{ $t('dealers.sendIt') }}</h3>
          <p>{{ $t('dealers.onePersonCoupons') }}</p>
        </div>
      </div>
      <div class="step">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="90" height="90"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1.95-9H15v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133A4.5 4.5 0 0 1 8.028 13H7v-2h1.027a4.5 4.5 0 0 1 7.788-2.543L14.114 9.59A2.5 2.5 0 0 0 10.05 11z" fill="rgba(0,64,255,1)"/></svg>
        <div class="texto">
          <h3>{{ $t('dealers.tradeWin') }}</h3>
          <p>{{ $t('dealers.finalPrice') }}</p>
        </div>
      </div>
    </div> -->
    <div class="card-content">
      <div class="contenedor-enlaces">
        <form @submit.prevent="onVerifyFormSubmit">
          <h3>{{ $t('dealers.clientCreation') }}</h3>
          <template>
            <div class="campo">
              <input class="input input--block" type="text" v-model.trim="register.firstname" :placeholder="$t('login.firstname')" :disabled="shouldEnableOtp">
            </div>
            <div class="campo">
              <input class="input input--block" type="text" v-model.trim="register.lastname" :placeholder="$t('login.lastname')" :disabled="shouldEnableOtp">
            </div>
            <div class="campo">
              <input class="input input--block" type="email" v-model.trim="register.email" :placeholder="$t('login.username')" :disabled="shouldEnableOtp">
            </div>
            <div class="campo">
              <input class="input input--block" type="password" v-model.trim="register.password" :placeholder="$t('login.password')" :disabled="shouldEnableOtp">
            </div>
          </template>
          <p v-if="shouldEnableOtp">{{$t('dealers.verificationOk')}}</p>
          <button class="button button--blue" type="submit" :title="$t('buttons.verify')" v-if="!register.isVerified">
            {{ $t('buttons.verify') }}
          </button>
        </form>
        <form class="otp" @submit.prevent="onCreateAccountSubmit">
          <h3>{{$t('dealers.howWorks')}}</h3>
          <p>{{ $t('dealers.clientCreationDescription') }}</p>
          <h4>1. {{$t('dealers.pincode')}}</h4>
          <vue-otp-input ref="otpInput" input-classes="otp-input" input-type="number" separator=" " :num-inputs="6" :is-input-num="true" @on-complete="onPinComplete"/>
          <h4>2. {{$t('dealers.planselect')}} ({{ $t('dealers.generalPrices') }})</h4>
          <div class="plan">
            <select v-model="register.planId" ref="subscriptionOptionSelect">
              <option v-for="option in subscriptionInfoList" :key="option.id" :value="option.id">{{ option.name }} ({{ (1.21*option.amount/100).toFixed(2) }}{{ $t('login.' + (option.period == 1 ? '€/month' : '€/year')) }})</option>
            </select>
            <button type="submit" class="button button--blue" :disabled="!shouldEnableOtp">{{ $t('buttons.create') }}</button>
          </div>
        </form>
      </div>
    </div>
    <div class="referred-users">
      <div class="tabs">
        <h2 class="resellers">{{ currentTabTitle }}&nbsp;&nbsp;<ChevronDownIcon @click.stop="toggleCurrentTab" style="cursor: pointer;"></ChevronDownIcon></h2>
        <ul class="collapse" ref="toggler">
          <li @click.stop="changeCurrentTab('clients')"> {{ $t('dealers.myClients') }}</li>
          <li @click.stop="changeCurrentTab('coupons')"> {{ $t('dealers.myCoupons') }}</li>
        </ul>
      </div>
      <template v-if="currentTab == 'coupons'">
        <div class="card" v-if="coupons.length > 0">
          <div class="card-title">
            <div class="columna cupon">
              <p>{{ $t('dealers.couponCode') }}</p>
              <img @click="sort('code')" v-if="!isRotateCoupon" src="/img/icons/Distribuidores/arrow-down.svg">
              <img @click="sort('code')" v-else class="flecha-girada" src="/img/icons/Distribuidores/arrow-down.svg">
            </div>
            <div class="columna beneficiario">
              <p>{{ $t('dealers.beneficiary') }}</p>
              <img @click="sort('email')" v-if="!isRotateBeneficiary" src="/img/icons/Distribuidores/arrow-down.svg">
              <img @click="sort('email')" v-else class="flecha-girada" src="/img/icons/Distribuidores/arrow-down.svg">
            </div>
            <div class="columna creacion">
              <p>{{ $t('dealers.creationDate') }}</p>
              <img @click="sort('ctime')" v-if="!isRotateCreate" src="/img/icons/Distribuidores/arrow-down.svg">
              <img @click="sort('ctime')" v-else class="flecha-girada" src="/img/icons/Distribuidores/arrow-down.svg">
            </div>
            <div class="columna canjeo">
              <p>{{ $t('dealers.redemptionDate') }}</p>
              <img @click="sort('utime')" v-if="!isRotateRedemption" src="/img/icons/Distribuidores/arrow-down.svg">
              <img @click="sort('utime')" v-else class="flecha-girada" src="/img/icons/Distribuidores/arrow-down.svg">
            </div>
          </div>
          <div class="card-content">
            <div id="listing">
              <div class="invoicelist">
                <coupon v-for="(item) in coupons" :key="item.id"
                  v-bind:code="item.code"
                  v-bind:email="item.email"
                  v-bind:ctime="item.ctime"
                  v-bind:utime="item.utime"
                  v-on:delete="onCouponDelete"
                  v-bind:id="item.id"> 
                </coupon>
              </div>
            </div>
          </div>
        </div>  
        <div class="card" v-else>
          <div class="card-content">
            <div class="false">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M14 3v18H3a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 1 0 0-5V4a1 1 0 0 1 1-1h11zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 1 0 0 5V20a1 1 0 0 1-1 1h-5V3z" fill="rgba(0,64,255,1)"/></svg>
              <h2 class="message">
                <span>{{ $t('dealers.noCoupon') }}</span>
              </h2>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="currentTab == 'clients'">
        <div class="card" v-if="accounts.length > 0">
          <table>
            <thead>
              <tr>
                <th class="hide-small">{{ $t('settings.companyName') }}</th>
                <th>{{ $t('login.username') }}</th>
                <th>{{ $t('dealers.creationDate') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in accounts" :key="item.handle" style="border: 0">
                <td class="hide-small">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M1 22a8 8 0 1 1 16 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm9.246-9.816A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22zm3.302-2.4A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784z" fill="var(--blue)"/></svg>
                    {{ item.name }}
                  </span>
                </td>
                <td>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M1 22a8 8 0 1 1 16 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm9.246-9.816A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22zm3.302-2.4A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784z" fill="var(--blue)"/></svg>
                    {{ item.email }}
                  </span>
                </td>
                <td>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2zm11 7H4v11h16V8zm-4.964 2.136l1.414 1.414-4.95 4.95-3.536-3.536L9.38 11.55l2.121 2.122 3.536-3.536z" fill="var(--blue)"/></svg>
                    {{ humanTime(item.ctime) }}
                  </span>
                </td>
                <td>
                  <button @click="() => onAccountLogin(item.handle)" class="button"><LogInIcon size="1.5x" style="margin-right: 0.5em"/>{{ $t('login.login') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>  
      </template>
    </div>
  </div>
</template>

<style scoped>
#resellers .card-content .contenedor-enlaces {
  max-width: 1200px;
}
#resellers .card-content .contenedor-enlaces form {
  flex: 40%;
}
#resellers .card-content .contenedor-enlaces form.otp {
  background-color: white;
  border-radius: 1em;
  padding: 0em 1em 1em 1em;
  text-align: left;
  flex: 60%;
}
#resellers .card-content .contenedor-enlaces form.otp div.plan {
  display: flex;
  justify-content: space-between;
}

#resellers .card-content .contenedor-enlaces form.otp div.plan select {
  max-width: 100%;
}
@media screen and (max-width: 900px) {
  #resellers .card-content .contenedor-enlaces form.otp div.plan {
    display: block;
  }
}

@media screen and (max-width: 700px) {
  #resellers .card-content .contenedor-enlaces {
    display: block;
  }
  #resellers .card-content .contenedor-enlaces form.otp {
    margin-top: 1em;
  }
  #resellers .card-content .contenedor-enlaces form.otp h3 {
    margin-top: 0em;
    padding-top: 1em;
  }
  #resellers .card-content .contenedor-enlaces form.otp div.plan select {
    margin-bottom: 1em;
    margin-right: 1em;
  }

  th.hide-small, td.hide-small {
    display: none;
  }
}
/*--------------*/
.tabs {
  position: relative;
  padding: 0.1em 0 0 0;
}
.tabs .resellers {
  display: flex;
  gap: 0.5em;
  align-items: center;
}
.tabs > ul {
  position: absolute;
  left: 1.5em;
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  top: calc(1.5em + 24px);
  z-index: 1;
  margin-top: 1em;
  border: solid 1px;
  opacity: 1;
  border-radius: 0.5em;
  overflow: hidden;
  transition: transform 200ms;
  transform-origin: top;
  background-color: white;
}
.tabs > ul.collapse {
  transform: scaleY(0);
}
.tabs > ul > li {
  padding: 1em 3em 1em 1em;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}
.tabs > ul > li:hover {
  background-color: var(--light-blue);
}
.space svg > circle:nth-child(2) {
  transition: stroke-dashoffset 2s 100ms;
}
/*--------------*/
.card table tbody tr td span {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}
.card table tr>*:first-child {
  padding-left: 0em;
}
.card table thead tr th:nth-child(1) {
  width: 30%;
}
.card table thead tr th:nth-child(2) {
  width: 40%;
}
.card table thead tr th:nth-child(3) {
  width: 20%;
}
.card table thead tr th:nth-child(4) {
  width: 10%;
}


</style>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';
// import { SendIcon } from 'vue-feather-icons';
import Coupon from '@/components/dealers/Coupon.vue';
import VueOtpInput from '@bachdgvn/vue-otp-input';
import { ChevronDownIcon, LogInIcon } from 'vue-feather-icons';

export default {
  name: 'dealers',
  components: {
    // SendIcon,
    Coupon,
    VueOtpInput,
    ChevronDownIcon,
    LogInIcon,
},
  data: function () {
    return {
      register: {
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        pin: '',
        isVerified: false,
        registrationId: null,
        planId: 0,
      },
      subscriptionInfoList: [],
      coupons: [],
      accounts: [],
      isRotateCoupon: false,
      isRotateBeneficiary: false,
      isRotateCreate: false,
      isRotateRedemption: false,
      id: '',
      isCardVisible: false,
      currentTab: 'clients',
    };
  },
  computed: {
    ...mapState(['req', 'sortOrder', 'reload', 'userInfo', 'accountInfo']),
    shouldEnableOtp() {
      return this.register.isVerified && this.register.registrationId;
    },
    currentTabTitle() {
      switch (this.currentTab) {
        case 'clients':
          return this.$t('dealers.myClients');
        case 'coupons':
          return this.$t('dealers.myCoupons');
      }
      return '';
    }
  },
  watch: {
    '$route': 'fetchData',
    'reload': function () {
      this.fetchData();
    }
  },
  async mounted () {
    this.fetchData();
    const {subscriptionInfoList} = await ibb.getSubscriptionOptionsWithFeatures(0xF);
    this.subscriptionInfoList = subscriptionInfoList.filter(option => option.id != 99);
    this.register.planId = this.subscriptionInfoList[0].id;
  },
  methods: {
    ...mapMutations(['setIdCoupon', 'setLoading', 'setEmailCoupon']),
    humanTime(time) {
      if (time === 0) {
        return '-';
      } else {
        return moment(time * 1000).format('DD/MM/YYYY');
      }
    },
    async fetchData() {
      // Reset view information.
      this.$store.commit('setReload', false);
      this.$store.commit('closeHovers');

      // Set loading to true and reset the error.
      this.setLoading(true);

      try {
        const [{coupons}, {accountPermissions}] = await Promise.all([
          ibb.getAccountCoupons(),
          ibb.getUserInfo(),
        ]);
        const accounts = await Promise.all(accountPermissions
        .filter(ap => ap.handle != this.accountInfo.handle)
        .map(async (account) => {
          const {email} = await ibb.getPublicAccountInfo(account.handle);
          return {
            ...account,
            email,
          };
        }));
        this.coupons = coupons;
        this.accounts = accounts;
      } catch (e) {
        this.$showError(e);
      }
    },
    toggleCurrentTab() {
      this.$refs.toggler.classList.toggle('collapse');
    },
    async changeCurrentTab(currentTab) {
      this.toggleCurrentTab();
      this.currentTab = currentTab;
    },
    async onVerifyFormSubmit() {
      // Check if email has been verified before (pin has been sent)
      if (!this.register.isVerified) {
        const action = await ibb.verifyEmail(this.register.email, this.register.firstname, this.register.lastname);
        if (action.error.type == Module.ErrorType.E_SUCCESS.value) {
          this.register.registrationId = action.text;
          this.register.isVerified = true;
          // ask for a pin in the interface
          return;
        }
        if (action.error.type != Module.ErrorType.E_DUPLICATE.value) {
          // TODO: handle unknown error
          return;
        }
        // user already exists
        this.register.isVerified = true;
        // TODO: handle user already exists
        return;
      }
    },
    onPinComplete(value) {
      this.$refs['subscriptionOptionSelect'].focus();
      this.register.pin = parseInt(value);
    },
    async onCreateAccountSubmit() {
      try {
        const {coupon} = await ibb.createResellerCoupon(this.register.email);
        await ibbLink.logout();
        await ibbLink.createAccountWithPlan(
          this.register.registrationId, 
          this.register.firstname, this.register.lastname,
          this.register.email, this.register.password,
          this.register.pin, '', // referrer code
          this.register.planId,
        );
        await ibbLink.addResellerCodeAsPaymentMethod(coupon.code);
        const {link} = await ibbLink.createJoinLink(this.userInfo.email);
        await ibbLink.logout();
        const {session: newSession} = await ibb.newSession();
        await ibbLink.resumeSession(newSession);
        const {accountHandle, session} = await ibbLink.checkJoinLink(link, this.userInfo.email);
        await ibbLink.joinAccountWithCurrentUser(accountHandle, session);
        await ibbLink.logout();
        await this.fetchData();
        this.reset();
      } catch (e) {
        this.$showError(e);
      }
    },
    reset() {
      this.register = {
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        pin: '',
        isVerified: false,
        registrationId: null,
        planId: this.subscriptionInfoList[0].id,
      };
      this.$refs['otpInput'].clearInput();
    },
    async sort (by) {
      if (by === 'code') {
        if (!this.isRotateCoupon) { //Orden ascendente
          this.coupons = this.coupons.sort((a, b) => {
            if (a.code < b.code) {
              return -1;
            } if (b.code < a.code ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.coupons = this.coupons.sort((a, b) => {
            if (a.code > b.code) {
              return -1;
            } if (b.code > a.code ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateCoupon = !this.isRotateCoupon;
      } else if (by === 'email') {
        if (!this.isRotateBeneficiary) { //Orden ascendente
          this.coupons = this.coupons.sort((a, b) => {
            if (a.email < b.email) {
              return -1;
            } if (b.email < a.email ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.coupons = this.coupons.sort((a, b) => {
            if (a.email > b.email) {
              return -1;
            } if (b.email > a.email ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateBeneficiary = !this.isRotateBeneficiary;
      } else if (by === 'ctime') {
        if (!this.isRotateCreate) { //Orden ascendente
          this.coupons = this.coupons.sort((a, b) => {
            if (a.ctime < b.ctime) {
              return -1;
            } if (b.ctime < a.ctime ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.coupons = this.coupons.sort((a, b) => {
            if (a.ctime > b.ctime) {
              return -1;
            } if (b.ctime > a.ctime ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateCreate = !this.isRotateCreate;
      } else if (by === 'utime') {
        if (!this.isRotateRedemption) { //Orden ascendente
          this.coupons = this.coupons.sort((a, b) => {
            if (a.utime < b.utime) {
              return -1;
            } if (b.utime < a.utime ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.coupons = this.coupons.sort((a, b) => {
            if (a.utime > b.utime) {
              return -1;
            } if (b.utime > a.utime ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateRedemption = !this.isRotateRedemption;
      }
    },
    onCouponDelete(id, email) {
      this.setEmailCoupon(email);
      this.setIdCoupon(id);
      this.$store.commit('showHover', 'delete-coupon');
      // TODO: remove permissions
    },
    onAccountLogin(handle) {
      this.$store.commit('setAccountHandle', handle);
      this.$store.commit('showHover', 'logout');
    },
  }
};
</script>
